import React, {Component} from "react";
import PropTypes from "prop-types";
import {_getAvailableRoles, _getUserDetail, _updateUserRoles} from "../../../../../services/apis/AdminServices";
import styles from "./UserPage.scss";
import Select from 'react-select';
import timeHuman from "../../../../../helpers/time/timeHuman";
import SetMembership from "../SetMembership/SetMembership";
import UserNote from "../UserNote/UserNote";
import {_changeEmail, _changeStatus} from "../../../../../services/apis/AdminUserServices";
import BillingHistory from "./components/BillingHistory";


class UserPage extends Component {
    state = {
        user: {},
        error: '',
        availableRoles: [],
        form: {
            email: ''
        }
    };

    componentDidMount() {
        this._fetchUserDetail();
        this._fetchRolesCanChange();
    }

    _fetchRolesCanChange = () => {
        return _getAvailableRoles()
            .then(result => {
                const {success, data} = result;

                if (success) {
                    this.setState({
                        availableRoles: data
                    });
                }
            });
    };

    _fetchUserDetail = () => {
        const {match} = this.props;
        const {userId} = match.params;

        _getUserDetail(userId)
            .then(result => {
                const {success, data, message} = result;

                if (success) {
                    this.setState({
                        user: data
                    });
                } else {
                    this.setState({
                        error: message
                    });
                }
            });
    };

    _handleChangeRoles = (options) => {
        const roles = options.map(option => option.value);
        const {user} = this.state;
        const userId = user._id;

        _updateUserRoles(userId, roles)
            .then(result => {
                const {success, data} = result;

                if (success) {
                    this.setState({
                        user: {
                            ...user,
                            roles: data
                        }
                    });
                }
            });
    };

    _getOptionsChangeRole = () => {
        const {availableRoles} = this.state;
        const {user} = this.state;
        const roles = user.roles || [];

        const mergeRoles = [...new Set([...roles, ...availableRoles])];

        return mergeRoles.map(role => ({
            value: role,
            label: role
        }));
    };

    _handleChangeEmailInput = (e) => {
        const {value} = e.target;

        this.setState(({form}) => ({
            form: {
                ...form,
                email: value
            }
        }));
    };

    _handleChangeEmail = (e) => {
        e.preventDefault();

        const {form, user} = this.state;
        const {email} = form;
        const userId = user._id;

        _changeEmail({userId, email})
            .then(response => {
                const {success, data, message} = response;

                if (success) {
                    const _email = data.email || email;

                    this.setState(({user, form}) => ({
                        user: {
                            ...user,
                            email: _email
                        },
                        form: {
                            ...form,
                            email: ''
                        }
                    }));
                } else {
                    alert(message);
                }
            })
            .catch(error => {
                alert(error.message || error);
            });
    };

    _handleChangeStatus = e => {
        const {value} = e.target;
        const {user} = this.state;
        const userId = user._id;

        _changeStatus({userId, status: value})
            .then(response => {
                const {success, data} = response;

                if (success) {
                    this.setState({
                        user: {
                            ...user,
                            status: data.status || value
                        }
                    });
                }
            });
    };

    render() {
        const {user, form} = this.state;
        const {match} = this.props;
        const {userId} = match.params;

        if (!user || !Object.keys(user).length) {
            return "Loading..."
        }

        const {email, profile, roles, membership, status} = user;
        const {name} = profile;

        const emailChange = form.email;

        return (
            <div className={styles.root}>
                <div className="Form form-inline">
                    <table className="table border-0">
                        <tbody>
                        <tr className={styles.field}>
                            <td>
                                <label>Name</label>
                            </td>
                            <td>
                                <span>{name}</span>
                            </td>
                        </tr>
                        <tr className={styles.field}>
                            <td>
                                <label>Email</label>
                            </td>
                            <td>
                                <span>{email}</span>

                                <form onSubmit={this._handleChangeEmail} className="Change">
                                    <input value={emailChange} onChange={this._handleChangeEmailInput} type="text"/>
                                    <button className="Email btn btn-secondary">Change email
                                    </button>
                                </form>
                            </td>
                        </tr>

                        <tr className={styles.field}>
                            <td>
                                <label>Status</label>
                            </td>
                            <td>
                                <select
                                    className="form-control"
                                    onChange={this._handleChangeStatus}
                                    name="status" value={status}>
                                    <option value="active">Active</option>
                                    <option value="blocked">Blocked</option>
                                </select>
                            </td>
                        </tr>

                        <tr className={styles.field}>
                            <td>
                                <label>Roles</label>
                            </td>
                            <td>
                                <div className={styles.roles}>
                                    <Select
                                        multi
                                        name="form-field-name"
                                        value={roles}
                                        onChange={this._handleChangeRoles}
                                        options={this._getOptionsChangeRole()}
                                    />
                                </div>
                            </td>
                        </tr>

                        {
                            membership &&
                            <tr className={styles.field}>
                                <td>
                                    <label>Membership</label>
                                </td>
                                <td>
                                    <div>
                                        Plan: {membership.plan.title}
                                    </div>

                                    <div>
                                        Start: {timeHuman(membership.start, 'DD/MM/YYYY')}
                                    </div>

                                    <div>
                                        Finish: {timeHuman(membership.finish, 'DD/MM/YYYY')}
                                    </div>
                                </td>
                            </tr>
                        }

                        <tr className={styles.field}>
                            <td>
                                <label>Set membership</label>
                            </td>

                            <SetMembership onChange={() => {
                                this._fetchUserDetail()
                            }} userId={user._id}/>
                        </tr>

                        <tr className={styles.field}>
                            <td>
                                <label>Notes</label>
                            </td>

                            <UserNote note={user.note || ''} onChange={() => {
                                this._fetchUserDetail()
                            }} userId={user._id}/>
                        </tr>

                        <tr className={styles.field}>
                            <td>
                                <label>Billing History</label>
                            </td>
                            <td>
                                <BillingHistory userId={userId}/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

UserPage.propTypes = {
    history: PropTypes.object,
};

export default UserPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/user/UserPage/UserPage.js